const fallbackImages = require.context(
  "./",
  false,
  /\.(jpg|jpeg|png|gif|webp|JPG|JPEG|PNG|GIF|WEBP)$/i
);

const images = fallbackImages
  .keys()
  .map((key) => fallbackImages(key))
  .sort((a, b) => {
    const nameA = a.split("/").pop().split(".")[0];
    const nameB = b.split("/").pop().split(".")[0];
    return nameA.localeCompare(nameB, undefined, { numeric: true });
  });

export default images;
